import src from "IMAGE";
export default { src, width: 53, height: 88, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
